
import BreadCrumbs from '@components/Breadcrumbs';
import Button from '@components/Button';
import Icon from '@material-ui/core/Icon';
import { apiClient } from '@services/api';
import { format, parseJSON } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useHistory, useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';

const s = {
  card:      { background: '#172B4D', borderRadius: '12px', marginBottom: '12px', overflow: 'hidden', fontFamily: 'Arial, sans-serif' },
  cardHead:  { padding: '14px 20px', borderBottom: '1px solid #1e3a5a', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  headTitle: { color: '#e8f0fb', fontSize: '15px', fontWeight: 'bold' },
  headSub:   { color: '#8ba5c4', fontSize: '12px' },
  row:       { display: 'flex', padding: '10px 20px', borderBottom: '1px solid #1e3a5a' },
  label:     { flex: 1, color: '#8ba5c4', fontSize: '13px' },
  value:     { flex: 1, color: '#e8f0fb', fontSize: '13px', textAlign: 'right' },
  colHead:   { flex: 1, color: '#62DEC2', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' },
  colHeadWide: { flex: 2, color: '#62DEC2', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' },
  valueWide: { flex: 2, color: '#e8f0fb', fontSize: '13px' },
};

class Content extends React.Component {
  render() {
    const exit = this.props.exit;
    const tourType = { tour: 'Passeio', combo: 'Combo', transfer: 'Traslado' };
    const language = { pt: 'Português', en: 'Inglês', es: 'Espanhol' };

    if (Object.keys(exit).length !== 0) {
      return (
        <div style={{ background: '#0f1e35', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
          {/* Card informações do passeio */}
          <div style={s.card}>
            <div style={s.cardHead}>
              <span style={s.headTitle}>Informações</span>
            </div>
            <div style={{ ...s.row, borderBottom: '1px solid #1e3a5a' }}>
              <span style={s.colHeadWide}>Produto</span>
              <span style={{ ...s.colHead, textAlign: 'center' }}>Local</span>
              <span style={{ ...s.colHead, textAlign: 'right' }}>Guia</span>
            </div>
            <div style={s.row}>
              <span style={s.valueWide}>{exit.travel_name}{exit.type === 'transfer' && exit.transfer_type ? ` (${exit.transfer_type})` : ''}</span>
              <span style={{ ...s.value, textAlign: 'center' }}>{tourType[exit.type]}</span>
              <span style={{ ...s.value, textAlign: 'right' }}>{exit.guide_name}</span>
            </div>
          </div>

          {/* Cards por cliente */}
          {exit.customers?.map((customer, idx) => {
            const addr = parseInt(exit.region)
              ? customer.addresses?.find(({ region_id }) => region_id == exit.region)
              : null;
            const hotel       = addr?.hotel        ?? exit.hotel_name;
            const address     = addr?.hotel_address ?? exit.address_hotel;
            const room        = addr?.room_number   ?? exit.room_number;
            const pendente    = Number(customer.total) - Number(customer.payments?.reduce((a, p) => a + Number(p.total), 0) || 0);
            const paxLabel    = (customer.kids_total && customer.kids_total != 0)
              ? `${customer.adults_total}+${customer.kids_total}`
              : customer.passagers;
            const timeLabel   = exit.type !== 'transfer'
              ? (customer.time_final
                  ? `Entre ${customer.time?.slice(0,5)} e ${customer.time_final?.slice(0,5)}`
                  : customer.time?.slice(0,5))
              : (exit.time ?? exit.time_final)?.slice(0,5);

            return (
              <div key={idx} style={s.card}>
                <div style={s.cardHead}>
                  <span style={s.headTitle}>
                    {customer.name} <span style={s.headSub}>(Idioma: {language[customer.language]})</span>
                  </span>
                  <span style={{ color: '#62DEC2', fontSize: '13px', fontWeight: 'bold' }}>
                    ⏰ {timeLabel}
                  </span>
                </div>
                {exit.type === 'transfer' && (
                  <div style={s.row}>
                    <span style={s.label}>Número do Voo</span>
                    <span style={s.value}>{exit?.flight_code}</span>
                  </div>
                )}
                <div style={s.row}><span style={s.label}>Hotel</span><span style={s.value}>{hotel}</span></div>
                <div style={s.row}><span style={s.label}>Endereço - {exit.type === 'tour' ? 'Passeio' : 'Traslado'}</span><span style={s.value}>{address}</span></div>
                <div style={s.row}><span style={s.label}>Número do quarto</span><span style={s.value}>{room}</span></div>
                <div style={s.row}><span style={s.label}>Telefone</span><span style={s.value}>{customer.phone}</span></div>
                <div style={s.row}><span style={s.label}>Passageiros</span><span style={s.value}>{paxLabel}</span></div>
                <div style={s.row}>
                  <span style={s.label}>Valor Pendente</span>
                  <span style={s.value}>
                    <NumberFormat
                      value={pendente || 0}
                      displayType="text"
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      thousandSeparator="."
                      isNumericString
                      prefix={`${process.env.REACT_APP_CURRENCY} `}
                    />
                  </span>
                </div>
                <div style={{ ...s.row, borderBottom: 'none' }}><span style={s.label}>Vendedor</span><span style={s.value}>{customer.seller_name}</span></div>
              </div>
            );
          })}
        </div>
      );
    } else {
      return (
        <div style={{ background: '#0f1e35', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
          <div style={s.card}>
            <div style={s.cardHead}><span style={s.headTitle}>Informações</span></div>
            <div style={s.row}><span style={{ color: '#8ba5c4', fontSize: '13px' }}>Nenhum veículo cadastrado para a saída</span></div>
          </div>
        </div>
      );
    }
  }
}

const Show = (props) => {
  const { type_user } = useParams();
  const { exit_id } = useParams();
  const { access_token } = useParams();
  const componentRef = useRef()
  const history = useHistory();
  const [exit, setExit] = useState({})
  const url = type_user === 'motorista' ? `driver/exit/${exit_id}` : `guide/exit/${exit_id}`

  const bradecrumbsConfig = [
    {
      title: `Início`,
      active: true,
      route: `/saidas/${type_user}/${access_token}`
    },
    {
      title: `Detalhes ${exit.travel_name !== undefined ? exit.travel_name : ''}`,
    },
    {
      title: `Saida do dia ${exit.tour_date !== undefined ? format(new Date(`${exit.tour_date} 00:00:00`), "dd/MM/yyyy") : ''}`,
    }
  ]

  const getExitDetails = url => {
    apiClient.httpInstance.get(url, {
      params: {
        access_token: access_token
      }
    }).then(response => {
      if (response.status === 200) {
        setExit(response.data);
      }
    });
  }

  useEffect(() => {
    getExitDetails(url);
  }, [url]);

  return <>
    <div className="px-4 md:px-20">
      <BreadCrumbs items={bradecrumbsConfig}/>
    </div>
    <div className="px-4 md:px-24 pb-4 pt-6">
      <div className="flex flex-wrap items-center justify-between mt-2 text-lg md:text-2xl text-blue gap-3">
        <span>Detalhes {exit.travel_name}</span>
        <div className="w-100 space-x-3">
          {/* <Button
            textcolor="#e8f0fb"
            padding="6px 15px"
            margintop="0px"
            width="200px"
            variant="outlined"
            onClick={null}
            bgColor="transparent"
          >
            Enviar por e-mail
          </Button> */}
          <ReactToPrint
            trigger={() => <Button
              textcolor="#FFF"
              padding="6px 15px"
              margintop="0px"
              width="200"
              customcolor={props.theme.color}
            >
              Visualizar PDF
            </Button>
            }
            content={() => componentRef.current}
            pageStyle={`
              @page { size: auto; margin: 10mm; }
              @media print {
                body { background-color: #0f1e35 !important; }
                * {
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                  color-adjust: exact !important;
                }
              }
            `}
          />
        </div>
      </div>
      {/* <div className="mb-4">
        <Button
          textcolor="#e8f0fb"
          padding="6px 15px"
          margintop="0px"
          width="100px"
          variant="outlined"
          bgColor="transparent"
          onClick={() => history.push(`/saidas/${type_user}/${access_token}/${props.permission}`)}
        >
          Voltar
        </Button>
      </div> */}
      <Content
        {...props}
        exit={exit}
        ref={componentRef}
      />
    </div>
  </>
}

export default Show;
